import { render, staticRenderFns } from "./user-purchase-request-list.vue?vue&type=template&id=770712ba&scoped=true&"
import script from "./user-purchase-request-list.vue?vue&type=script&lang=js&"
export * from "./user-purchase-request-list.vue?vue&type=script&lang=js&"
import style0 from "./user-purchase-request-list.vue?vue&type=style&index=0&id=770712ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770712ba",
  null
  
)

export default component.exports